import { render, staticRenderFns } from "./ParamsLeft.vue?vue&type=template&id=bd378840&scoped=true"
import script from "./ParamsLeft.vue?vue&type=script&lang=js"
export * from "./ParamsLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd378840",
  null
  
)

export default component.exports